import { useSearch } from '@tanstack/react-router'

import { kioskIntegration } from '@/integrations/kiosk'
import { getPlatform } from '@/utils/get-platform'

export function useKiosk() {
  const search = useSearch({ strict: false })
  const platform = getPlatform(search)

  return { kioskIntegration, platform }
}
